// Copyright (c) 2016 Deere & Company

import LaborAdditiveSummary from '@deere/cps-it.warranty-model-factory/lib/labor-additive-summary';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateLaborAdditiveSummary = (state, action) =>
    LaborAdditiveSummary.update(state, {
        $set: action.laborAdditiveSummary
    });

export default (state = getDefaultState().laborAdditiveSummary, action) => {

    const actionTypes = {
        [actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SUMMARY]: updateLaborAdditiveSummary
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/labor-additive/reducers/labor-additive-summary.js